import { ImageFragmentFragment } from '../../../__generated__/graphql';
import AppImage from '../../../components/AppImage';
import Video from '../../../components/Video';

import style from './right-content.module.css';

type RightContentType =
  | 'image'
  | 'none'
  | 'video';

interface RightContentProps {
  image: ImageFragmentFragment | null | undefined;
  imageClassName: string;
  rightContentType: null | string | undefined;
  videoUrl: null | string | undefined;
}

const getRightContentComponent = ({
  image,
  imageClassName,
  rightContentType,
  videoUrl,
}: RightContentProps) => {
  switch (rightContentType as null | RightContentType | undefined) {
    case 'image':
      return image
        ? (
          <AppImage
            className={imageClassName}
            fallbackHeight={400}
            fallbackWidth={550}
            fetchPriority="high"
            image={image}
            priority
          />
        )
        : null;
    case 'video':
      return videoUrl
        ? (
          <Video
            src={videoUrl}
            wrapperClassName={style.video}
          />
        )
        : null;
    case 'none':
    case undefined:
    case null:
    default:
      return null;
  }
};

const RightContent = (props: RightContentProps) => {
  return getRightContentComponent(props);
};

export default RightContent;
